import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from '../useFetcher';

export type MappedAgenciesType = {
  slug: string;
  agency: {
    zip: string | null;
    city: {
      name: string;
      country: {
        code: string;
        name: string;
      };
    };
  };
};

type Payload = {
  country: string;
  lat?: number;
  lang?: number;
};

export const useGetNearbyMappedAgencies = () => {
  const { data, fetcher, error, isLoading } = useFetcher<MappedAgenciesType[]>([]);

  const getNearbyMappedAgencies = useCallback(
    ({ lang, lat, country }: Payload) => {
      fetcher(EndPoints.nearbyMappedAgencies, {
        requiredToken: false,
        body: {
          country,
          lat,
          lang,
        },
      });
    },
    [fetcher],
  );

  return {
    getNearbyMappedAgencies,
    data,
    error,
    isLoading,
  };
};
